import { apiRequest } from "./_fetch";

export interface ServiceabilityInfo {
  pincode: string;
  known: boolean;
  serviceable: boolean;
  cod_available: boolean;
  estimated_days: number | null;
  etd: string | null;
}

/** Shiprocket deliverability/COD/ETA for a pincode. Soft-fails to null — the cart
 * never blocks on a serviceability lookup. */
export async function getServiceability(pincode: string): Promise<ServiceabilityInfo | null> {
  try {
    return await apiRequest<ServiceabilityInfo>(`/serviceability/${encodeURIComponent(pincode)}`);
  } catch {
    return null;
  }
}
